import { css } from "lit";

export const styles = css`
  .containers {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .section-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    line-height: 20px;
    padding-bottom: var(--sds-size-space-800);
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .recent-message-section {
    display: flex;
    flex-direction: column;
  }

  .recent-message-section .section-title {
    padding-bottom: var(--sds-size-space-400);
  }

  .messages-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sds-size-space-400);
    margin-bottom: var(--sds-size-space-400);
  }

  .messages-header .section-title {
    padding-bottom: 0;
    white-space: nowrap;
  }

  .messages-filter {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    flex-wrap: wrap;
  }

  .delete-confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .delete-confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .confirmation-buttons {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300);
  }

  .create-short-label {
    display: none;
  }

  @media (max-width: 768px) {
    .section-title {
      font-size: var(--sds-typography-scale-03);
    }

    .messages-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .create-icon,
    .create-full-label {
      display: none;
    }

    .create-short-label {
      display: inline;
    }
  }
`;
